import { gql } from "@apollo/client";

export const UserFragment = gql`
  fragment userFragment on User {
    id
    createdAt
    email
    firstName
    lastName
    personas
    phone
    role
    onboardingStep
    organization {
      id
      name
    }
  }
`;
